import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Box, Button } from 'fw/components'
import { ContentBody } from 'areas/shared/components';
import * as FormManager from 'fw/forms/form/FormManager';
import * as Notifications from 'fw/globals/Notifications';
import * as API from 'modules/app/API';
import * as Modals from 'fw/globals/Modals';
import { faCheck, faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { faCcPaypal, faCcStripe, faCcAmex, faCcDiscover, faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as App from 'modules/app/App'

library.add(faCheck, faCreditCard, faCcPaypal, faCcStripe, faCcAmex, faCcDiscover, faCcMastercard, faCcVisa);

const countDownSeconds = 10;

class PreQualificationPaymentAccepted extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => {
        return {
            loading: true,
            title: "",
            form: {
                activeManagement: true,
                capitalContribution: true,
                abilityToPerform: true
            },
            seconds: countDownSeconds,
            paymentError: "",
            checkSeconds: true,
            statusCompleted: false
        };
    }

    tick() {
        if (this.state.checkSeconds){
            if (this.state.seconds === 0){
                this.get(this.props.match.params.vobKey, this.props.match.params.vobFeinKey);
                this.setState(prevState => ({
                    seconds: countDownSeconds
                }));
            }
            else {
				this.setState(prevState => ({
					seconds: prevState.seconds - 1
				}));
			}
        }
      }

    componentDidMount() {
        this.savePayment(this.props.match.params.vobKey, this.props.match.params.vobFeinKey);
        this.interval = setInterval(() => this.tick(), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
      }

      get = (vobKey, vobFeinKey) => {
        var rq = {
            vobKey: vobKey !== undefined ? vobKey : null,
            vobFeinKey: vobFeinKey !== undefined ? vobFeinKey : null
        };

        API.Certification.get('/certificationSetup/getPreQualificationPaymentStatus', rq,
            {
                success: (r) => {
                    if (r.data.certificationStatusCode === 'PGR') {
                        this.props.history.push(r.data.isRenewal
                            ? '/certification/renewalOneSheet/' + r.data.certificationKey
                            : '/certification/certification/' + r.data.stepCode + '/' + r.data.certificationKey);
					}
                    else {
                        if (r.data.paymentErrorDescription !== null && r.data.paymentErrorDescription !== ""){
                            this.setState((prevState, props) => ({
                                paymentError: r.data.paymentErrorDescription,
                                checkSeconds:false,
                                statusCompleted: true
                            }));
                        }
                        else {
                            this.setState((prevState, props) => ({
                                statusCompleted: true
                            }));
						}
					}
                }
            });
    }

    savePayment = (vobKey, vobFeinKey) => {
        const me = this;

        var rq = {
            vobKey: vobKey !== undefined ? vobKey : null,
            vobFeinKey: vobFeinKey !== undefined ? vobFeinKey : null
        };
        

        API.Certification.post('/certificationSetup/savePreQualificationPayment', rq,
        {
            success: (r) => {
                if (r.message !== null) {
                    Notifications.success(r.message);
				}

                FormManager.reset();
				
                if (r.data.certificationStatusCode === 'PGR'){
                    App.context().showMenu = true;
                    this.props.history.push(r.data.isRenewal
                        ? '/certification/renewalOneSheet/' + r.data.certificationKey
                        : '/certification/certification/' + r.data.stepCode + '/' + r.data.certificationKey);
                }
                else {
                    if (r.data.paymentErrorDescription !== null && r.data.paymentErrorDescription !== ""){
                        this.setState((prevState, props) => ({
                            paymentError: r.data.paymentErrorDescription,
                            checkSeconds:false,
                            statusCompleted: true
                        }));
                    }
                    else {
                    	this.setState((prevState, props) => ({
                            statusCompleted: true
                        }));
					}
                }
            },
            error: (r) => {
                if (r.data && r.data.rowVersion) {
                    Modals.confirm(r.error.errorMessage,
                        function () {
                            me.save(r.data.rowVersion);
                        },
                        function () {
                            me.get(r.data.vobKey);
                        }
                    );
                } else {
                    Notifications.error(r.error.errorMessage);
                }
            }
        });
    }

    onChange = (form, callback) => {
        this.setState({ form }, callback);
    }

    cancel = () => {
        this.props.history.push('/');
    }

    render() {
        return (
            <ContentBody>
                <Row><Col>&nbsp;</Col></Row>
                <Row>
                    <Col md={4}></Col>
                    <Col className="col-xs-1-10 text-center">
                        <p style={{ fontSize: '13px' }}>
                            Pre-Qualification
                        </p>
                        <React.Fragment>
                            <FontAwesomeIcon icon={['fas', 'check']} size="3x" style={{ color: '#2A77E4' }} className="my-icon" />
                            <p style={{ fontSize: '13px' }}>
                                Completed
                            </p>
                        </React.Fragment>
                    </Col>
                    <Col md={2}></Col>
                    <Col className="col-xs-1-10 text-center">
                        <p style={{ fontSize: '13px' }}>
                            <strong>Payment</strong>
                        </p>
                        <FontAwesomeIcon icon={['fas', 'credit-card']} size="3x" style={{ color: '#2A77E4' }} />
                        <p style={{ fontSize: '13px' }}>
                            <strong>Completed</strong>
                        </p>
                    </Col>
                    <Col md={4}></Col>
                </Row>
                <ContentBody>
                    <Row>
                        <Col md={12}>
                            <Box>
                                <Row>
                                    <Col md={12}>
                                        <strong>Pre-Qualification Completed</strong>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <hr />
                                    </Col>
                                </Row>
                                {this.state.statusCompleted ?
                                (<div>
                                    {this.state.paymentError === null || this.state.paymentError === "" ?
                                        (<div>
                                            <Row>
                                                <Col md={12} className="text-center">
                                                    <h3><u>Your payment is pending confirmation</u></h3>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <br />
                                            </Row>
                                            <Row>
                                                <Col md={12} className="text-center">
                                                    VOCS is awaiting for PayPal's confirmation.
                                                    <div style={{ marginTop: '3px' }}>Please try again in a few minutes to continue with the certification process.</div>
                                                    <br />
                                                    Please contact <a href='mailto:certification@nvbdc.org'>certification@nvbdc.org</a> if you are unable to start your application form.
                                                    <br /><br />
                                                    <em>(Your payment will be checked again automatically in <b>{this.state.seconds} seconds</b>)</em>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md={12}>
                                                    <br />
                                                </Col>
                                            </Row>
                                            <Row className="text-right">
                                                <Col md={12}>
                                                    <Button type="button" id="btnCancel" bsStyle="danger" title="Cancel"
                                                        onClick={() => this.cancel()}>
                                                        Cancel
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </div>)
                                        :
                                        (<div>
                                            <Row>
                                                <Col md={12} className="text-center">
                                                    <h3 style={{ color: 'red' }}><u>Attention!</u></h3>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <br />
                                            </Row>
                                            <Row>
                                                <Col md={12} className="text-center">
                                                    <em>
                                                        There have been problems with your payment's PayPal verification.<br />
                                                        Please get in touch for more information.<br /><br />
                                                    </em>
                                                    <p style={{color:'red'}}>Error Code(s): {this.state.paymentError}<br /></p>
                                                </Col>
                                            </Row>
                                        </div>)
                                    }
                                </div>)
                                :null }
                                <Row className="text-right">
                                    <Col md={12}>
                                        
                                    </Col>
                                </Row>
                            </Box>
                        </Col>
                    </Row>
                </ContentBody>
            </ContentBody>
        )
    }
}

export default PreQualificationPaymentAccepted;



// WEBPACK FOOTER //
// ./src/areas/certification/preQualification/PreQualificationPaymentAccepted.js